export const MOCK_INFO_OPTIONS = {
  currency: [
    { label: 'EUR', value: 'EUR' },
    { label: 'GBP', value: 'GBP' },
    { label: 'USD', value: 'USD' },
  ],
  preferred_communication: [
    { label: 'Email', value: 1 },
    { label: 'Phone', value: 2 },
    { label: 'Post', value: 3 },
  ],
  salutation: [
    { label: 'Sehr geehrte Frau', value: 178 },
    { label: 'Sehr geehrter Herr', value: 179 },
    { label: 'Sehr geehrte Damen und Herren', value: 180 },
  ],
  status: [
    { label: 'Single', value: 366 },
    { label: 'With child', value: 367 },
    { label: 'Refused', value: 369 },
  ],
}
